import '../../src/css/main.scss';

import './sliders.js';

// Init App
document.addEventListener('readystatechange', (event) => {
  if (event.target.readyState === 'complete') {
    // loadClass
    if (document.getElementById('theApp')) {
      const theApp = document.getElementById('theApp');
      theApp.classList.add('is-loaded');
    }

    // Init
    //initApplication();
  }
});

function myFunction() {
  // const btn = document.getElementById("test");
  // const apiLink = "https://jsonplaceholder.typicode.com/users";
  // const res = await fetch(apiLink, {
  //   method: "GET",
  // });
  console.log('>>>>>>>>>>>');
}
// await getData();
